<template>
    <div class="textContainer">
        <div v-if="details">
            <div class="newbox pt-4">
                <p class="left">Typ av känslighet</p>
                <p class="right">
                    {{ translateHyperSensitivity(details.typeOfSensitivity) }}
                </p>
            </div>
            <div class="newbox">
                <p class="left">Kommentar</p>
                <p class="right">{{ details.comment }}</p>
            </div>
            <div class="newbox">
                <p class="left">Visshetsgrad</p>
                <p class="right">
                    {{ details.degreeOfCertainty_display?.displayName }}
                </p>
            </div>
            <div class="newbox">
                <p class="left">Allvarlighetsgrad</p>
                <div class="exclaim rightSeverity right">
                    <p class="alertSign" v-if="item.degreeOfSeverity === 3">! &nbsp;</p>
                    <p class="pNested">
                        {{ details.degreeOfSeverity_display?.displayName }}
                    </p>
                </div>
            </div>
            <div class="newbox">
                <p class="left">Giltighetstid</p>
                <p class="right">
                    {{ details.validityTimePeriodStart }} -
                    {{ details.validityTimePeriodEnd ? details.validityTimePeriodEnd : "~" }}
                </p>
            </div>
            <div v-if="this.item.typeOfSensitivity === 'OtherHyperSensitivity' && details.agent" class="newbox">
                <p class="left">Överkänslighet</p>
                <p class="right">{{ details.agent }}</p>
            </div>
            <!--<div v-if="this.item.typeOfSensitivity === 'OtherHyperSensitivity' && details.agentCode_display.displayName"
                 class="newbox">
                <p class="left">Överkänslighet</p>
                <p class="right">{{ details.agentCode_display.displayName }}</p>
            </div>-->
            <div
                v-if="this.item.typeOfSensitivity === 'PharmaceuticalHyperSensitivity' && details.atcSubstance_display"
                class="newbox"
            >
                <p class="left">ATC-kod</p>
                <p class="right">
                    {{ details.atcSubstance_display.displayName }}
                </p>
            </div>
            <div
                v-if="this.item.typeOfSensitivity === 'PharmaceuticalHyperSensitivity' && details.noneATCSubstance"
                class="newbox"
            >
                <p class="left">Substans ej enligt ATC</p>
                <p class="right">{{ details.noneATCSubstance }}</p>
            </div>
            <div
                v-if="
                    this.item.typeOfSensitivity === 'PharmaceuticalHyperSensitivity' && details.noneATCSubstanceComment
                "
                class="newbox"
            >
                <p class="left">Kommentar till "Substans ej enligt ATC"</p>
                <p class="right">{{ details.noneATCSubstanceComment }}</p>
            </div>
            <div
                v-if="
                    this.item.typeOfSensitivity === 'PharmaceuticalHyperSensitivity' &&
                    details?.pharmaceuticalProduct_display
                "
                class="newbox pb-4"
            >
                <p class="left">Läkemedel</p>
                <div class="right">
                    <p class="pNested" v-for="product in details?.pharmaceuticalProduct_display" :key="product.id">
                        {{ product.displayName }}
                    </p>
                </div>
            </div>
        </div>

        <div v-if="!details" class="skeletonBox" :class="{ nullifiedRed: item.is_nullified }">
            <skeleton height="14px" :min-width="15" :max-width="40" radius="3px" margin="0 0 20px 0"></skeleton>
            <skeleton height="14px" :min-width="15" :max-width="40" radius="3px" margin="0 0 20px 0"></skeleton>
            <skeleton height="14px" :min-width="15" :max-width="40" radius="3px" margin="0 0 20px 0"></skeleton>
            <skeleton height="14px" :min-width="15" :max-width="40" radius="3px" margin="0 0 20px 0"></skeleton>
            <skeleton height="14px" :min-width="15" :max-width="40" radius="3px" margin="0 0 20px 0"></skeleton>
        </div>
    </div>
</template>

<script>
    import { mapActions } from "vuex";
    import Skeleton from "@/components/widgets/Skeleton.vue";

    export default {
        name: "hyperSensitivityTextbox",
        props: ["item"],
        components: {
            Skeleton,
        },
        data() {
            return {
                type: "hs",
                details: null,
            };
        },
        methods: {
            ...mapActions("alertInformation", ["loadDetailsInformation"]),
            async loadDetails() {
                let type;
                switch (this.item.typeOfSensitivity) {
                    case "PharmaceuticalHyperSensitivity":
                        type = "phs";
                        break;
                    case "OtherHyperSensitivity":
                        type = "ohs";
                        break;
                    default:
                        type = this.item.typeOfSensitivity;
                }
                try {
                    const response = await this.loadDetailsInformation({
                        pk: this.item.pk,
                        type,
                    });
                    if (response) {
                        this.details = response;
                    }
                    // eslint-disable-next-line
                } catch (e) {}
            },
            translateHyperSensitivity(name) {
                switch (name) {
                    case "OtherHyperSensitivity":
                        return "Överkänslighet";
                    case "PharmaceuticalHyperSensitivity":
                        return "Läkemedelsöverkänslighet";
                    default:
                        return name;
                }
            },
        },
        mounted() {
            this.loadDetails();
        },
    };
</script>

<style scoped>
    .textContainer {
        background-color: #f3f5f9;
        margin: auto -15px auto -15px;
        flex: 1 1 auto;
    }

    .disabledAlertInformation {
        opacity: 0.7;
    }

    .newbox {
        margin-left: 51px;
        display: flex;
        flex-direction: row;
        width: 100%;
    }

    .left {
        display: flex;
        flex-direction: column;
        width: 15%;
        color: #277692;
        font-family: Roboto Medium;
        margin-right: 10px;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 16px;
    }

    .right {
        display: flex;
        flex-direction: column;
        width: 75%;
        color: #354052;
        font-family: Roboto;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 16px;
    }

    .rightSeverity {
        display: flex;
        flex-direction: row;
        width: 75%;
        color: #354052;
        font-family: Roboto;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 16px;
    }

    .pNested {
        color: #354052;
        font-family: Roboto;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 16px;
    }

    .skeletonBox {
        display: flex;
        flex-direction: column;
        padding: 30px 50px;
        background-color: #f3f5f9;
        width: 1015px;
    }
</style>
